export const USB_CONNECTION_RETRY = 'isUsbConnectionRetry';
